
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_9099_25192","maskUnits":"userSpaceOnUse","x":"15","y":"15","width":"9","height":"9"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.322 15.546h7.981v7.982h-7.98v-7.982z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#mask0_9099_25192)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.303 19.537a3.99 3.99 0 11-7.981 0 3.99 3.99 0 017.981 0z","fill":"#3895D0"}})]),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask1_9099_25192","maskUnits":"userSpaceOnUse","x":"10","y":"15","width":"9","height":"9"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.697 15.546h7.98v8.053h-7.98v-8.053z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#mask1_9099_25192)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.688 23.6l-2.536-1.267-1.455-2.76c0-2.224 1.787-4.027 3.99-4.027 2.204 0 3.99 1.803 3.99 4.026 0 2.224-1.786 4.027-3.99 4.027z","fill":"#F9B621"}})]),_c('path',{attrs:{"d":"M25.889 18.685v-3.463c0-.982-.796-1.778-1.778-1.778H9.89c-.982 0-1.778.796-1.778 1.778v3.466M1 13.444l12.8 9.6a5.333 5.333 0 006.4 0l12.8-9.6m-1.394-2.643L20.243 2.099a5.333 5.333 0 00-6.485 0L2.393 10.8A3.555 3.555 0 001 13.624v14.043A5.333 5.333 0 006.333 33h21.334A5.333 5.333 0 0033 27.667V13.624c0-1.107-.515-2.15-1.394-2.823z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    